import type { SxProps, Theme } from "@mui/material/styles";
import { colors } from "../../../../../utils/colors";

const dashedBorder = `1px dashed ${colors.border_gray_color}`;
const headerDashedBorder = "1px dashed rgba(255, 255, 255, 0.35)";

export const pipelineAgingAnalysisConfig = {
  minHeight: 400,
  titleAlign: "left" as const,
};

export const getPipelineAgingAnalysisTitleSx = (
  titleAlign: "left" | "center" | "right",
): SxProps<Theme> => ({
  px: 2,
  mb: "0.25rem",
  fontWeight: 500,
  fontSize: "16px",
  color: colors.grayish_blue,
  textAlign: titleAlign,
});

export const pipelineAgingAnalysisStyles = {
  root: {
    minWidth: 0,
  },
  emptyStateContainer: {
    minWidth: 0,
    px: 2,
    py: 6,
    minHeight: pipelineAgingAnalysisConfig.minHeight,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  tableWrapper: (loading: boolean) => ({
    px: 2,
    pt: 8,
    opacity: loading ? 0.5 : 1,
    minWidth: 0,
  }),
  table: {
    width: "100%",
    borderCollapse: "collapse" as const,
    border: `1px solid ${colors.border_gray_color}`,
    backgroundColor: colors.white,
  },
  headerRow: {
    backgroundColor: colors.chart_gray,
  },
  headerCell: {
    color: colors.white,
    fontWeight: 600,
    fontSize: "0.8125rem",
    px: 2,
    py: 2,
    textAlign: "left" as const,
    verticalAlign: "middle" as const,
    borderBottom: headerDashedBorder,
    borderRight: headerDashedBorder,
    "&:last-child": {
      borderRight: "none",
    },
  },
  firstColumnBodyCell: {
    backgroundColor: "#F7F8FC",
  },
  bodyRow: {
    backgroundColor: colors.white,
  },
  bodyCell: {
    px: 2,
    py: 1.5,
    fontSize: "0.8125rem",
    verticalAlign: "middle" as const,
    borderBottom: dashedBorder,
    borderRight: dashedBorder,
    "&:last-child": {
      borderRight: "none",
    },
  },
  bodyCellLeft: {
    textAlign: "left" as const,
  },
  bodyCellCenter: {
    textAlign: "center" as const,
  },
  bucketLink: {
    color: colors.info_blue,
    fontSize: "0.8125rem",
    fontWeight: 500,
  },
  pipelineValue: {
    color: colors.black,
    fontSize: "0.8125rem",
    fontWeight: 500,
  },
  distributionBarContainer: {
    width: "100%",
    height: 28,
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
  },
  distributionBarTrack: {
    width: "100%",
    height: 18,
    display: "flex",
    alignItems: "center",
  },
  distributionBar: (percentage: number) => ({
    height: 28,
    width: `${percentage}%`,
    minWidth: percentage > 0 ? 4 : 0,
    backgroundColor: colors.bar_gray,
    borderRadius: 0,
  }),
};
